// How Otto prints a NUMERIC filter value.
//
// One rule, in one place, because a year is a number but not a QUANTITY: 1990 is a label, and
// "Year Built < 1,990" reads as a bug in the product. Two callers format these values — the wildcard pill
// in FilterAssistant.jsx and the table-view proposal summary — and both had the same defect independently,
// which is why the rule moved here instead of being patched twice.
//
// Caught 2026-09-10 in a recorded What's New clip: the shot framed the pill closely enough to read it.

// Whole word "year"/"years", so `year_built`, `installed_year`, `maintenance_years.year` and the label
// "Year Built" all match, while "yearly" does not. Underscores and dots count as word boundaries here.
const YEAR_WORD = /(^|[^a-z])years?([^a-z]|$)/i;

/**
 * Is this field a year?
 *
 * Decided by the FIELD — its declared type, key, or label — never by the value. A $1,990 cost is a
 * four-digit number too, and it must keep its separator; only the field can tell the two apart.
 */
export const isYearField = ({ type, field, label } = {}) =>
    String(type || "").toLowerCase() === "year" ||
    YEAR_WORD.test(String(field || "")) ||
    YEAR_WORD.test(String(label || ""));

/**
 * A numeric filter value as a pill or summary shows it: years bare, everything else with separators.
 * Anything unparseable is returned as-is rather than mangled into "NaN".
 */
export const formatNumericValue = (value, fieldInfo = {}) => {
    if (value == null || value === "") return "";
    const n = Number(String(value).replace(/,/g, ""));
    if (!Number.isFinite(n)) return String(value);
    return isYearField(fieldInfo) ? String(n) : n.toLocaleString();
};
